import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {z} from 'zod';
import dedent from 'dedent';

const toolName = 'search-styles' as const;

export const searchStylesArgsSchema = z.object({
  selectors: z.array(z.string()).describe(
    dedent`
      CSS selectors to look up. Batch multiple selectors in one call.

      Only class selectors and basic pseudo-classes (:hover, :focus, :active) are accepted. No nested, ID, or attribute selectors.

      ✅ .button, .button.is-secondary, .button:hover, .input:focus
      ❌ primary-button (missing dot), #some-id, .button .child, .container:first-child
      `
  ),
});

export type SearchStylesArgs = z.infer<typeof searchStylesArgsSchema>;

export const searchStylesTool = defineToolRegistryManifest({
  id: toolName,
  type: 'designer',
  permission: [{resource: 'SiteStyleBlock', action: 'read'}],
  prettyName: 'Search styles',
  prettyStatus: {
    executed: 'Searched styles',
    executing: 'Searching styles',
    failed: 'Failed to search styles',
  },
  confirmBeforeExecuting: false,
  timeout: 30000,
  llmTool: {
    name: toolName,
    description: dedent`
      Returns applied CSS styles for given selectors, including ancestor and descendant styles. Batch multiple selectors in one call. Use get-all-selectors-from-site first to discover existing classes before creating new ones.
    `,
    inputSchema: searchStylesArgsSchema,
  },
  isConcurrencySafe: () => true,
  isReadOnly: () => true,
});
